import React, { useState } from 'react'; 
import { useParams } from 'react-router-dom';
import { 
  FaCog, FaGasPump, FaCarSide, FaFan, FaUserFriends, 
  FaTachometerAlt, FaCheckCircle 
} from 'react-icons/fa';
import AddressModal from '../components/AddressModal'; // <-- Starts the booking process

import { allCars } from '../components/carData';
import CarListings from '../components/CarListings';

const SpecItem = ({ icon, label, value }) => (
  <div className="flex flex-col items-center text-center p-4">
    <div className="text-amber-400 text-3xl mb-2">{icon}</div>
    <p className="text-sm text-slate-400">{label}</p>
    <p className="font-semibold text-white">{value}</p>
  </div>
);

const EquipItem = ({ label }) => (
  <li className="flex items-center">
    <FaCheckCircle className="text-amber-400 mr-2" />
    <span className="text-slate-400">{label}</span>
  </li>
);

const Details = () => {
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [confirmationMsg, setConfirmationMsg] = useState(null); 
  
  const car = allCars.find(c => c.id === id);

  if (!car) {
    return (
      <div className="text-center py-20 bg-slate-950 text-white">
        <h1 className="text-3xl font-bold">Car not found!</h1>
      </div>
    );
  }
  
  const handleOpenModal = () => setIsModalOpen(true); 
  
  const handlePaymentSuccess = (msg) => { 
    setConfirmationMsg(msg);
    setTimeout(() => setConfirmationMsg(null), 8000); 
  };
  
  const numericPrice = car.price.replace(/[^\d.]/g, ''); 
  
  // Package car data to pass through modals (Address -> Payment)
  const carData = {
    carName: car.name,
    carPrice: numericPrice,
    carImage: car.image, 
    carId: car.id,
    onPaymentSuccess: handlePaymentSuccess
  };

  return (
    <div className="bg-slate-950 pt-20">
      
      {/* Confirmation Message Display */}
      {confirmationMsg && (
          <div className="p-3 bg-green-600 text-white text-center font-semibold fixed w-full top-16 left-0 z-20">
              {confirmationMsg}
          </div>
      )}
      
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          
          <div>
            <div className="bg-slate-800 h-96 rounded-lg flex items-center justify-center mb-4">
              <img src={car.image} alt={car.name} className="w-full h-full object-cover rounded-lg" />
            </div>
          </div>
          
          <div>
            <h1 className="text-4xl font-bold mb-2 text-white">{car.name}</h1>
            <p className="text-2xl text-slate-400 mb-6">${car.price}<span className="text-lg">/day</span></p>
            
            <h2 className="text-xl font-bold mb-4 text-white">Technical Specification</h2>
            <div className="grid grid-cols-3 gap-4 border border-slate-700 rounded-lg p-4 mb-6">
              <SpecItem icon={<FaCog />} label="Gearbox" value={car.specs.gearbox} />
              <SpecItem icon={<FaGasPump />} label="Fuel" value={car.specs.fuel} />
              <SpecItem icon={<FaCarSide />} label="Doors" value={car.specs.doors} />
              <SpecItem icon={<FaFan />} label="Air Conditioner" value={car.specs.ac} />
              <SpecItem icon={<FaUserFriends />} label="Seats" value={car.specs.seats} />
              <SpecItem icon={<FaTachometerAlt />} label="Distance" value={car.specs.distance} />
            </div>
            
            {/* RENT A CAR BUTTON - Opens ADDRESS MODAL */}
            <button 
              onClick={handleOpenModal} 
              className="w-full bg-amber-400 text-slate-950 py-3 rounded-lg font-semibold text-lg hover:bg-amber-500 mb-6"
            >
              Rent a car
            </button>
            
            <h2 className="text-xl font-bold mb-4 text-white">Car Equipment</h2>
            <div className="grid grid-cols-2 gap-4">
              <ul className="space-y-2">
                {car.equipment.slice(0, 3).map(item => <EquipItem key={item} label={item} />)}
              </ul>
              <ul className="space-y-2">
                {car.equipment.slice(3).map(item => <EquipItem key={item} label={item} />)}
              </ul>
            </div>
          </div>
          
        </div>
      </section>
      
      <CarListings title="Other cars" />

      {isModalOpen && (
        <AddressModal 
          carData={carData} 
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
}

export default Details;